import React from 'react'

const WeatherContext = React.createContext()
WeatherContext.displayName = 'WeatherContenxt'
export default WeatherContext
